import './execution.css'
import React, {useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import Box from '../../component/Box/Box'
import TextPropertyValue from '../../component/Information/TextPropertyValue'
import LoadingV2 from '../../component/Loading/LoadingV2'
import InventoryService from '../../services/InventoryService'
import Notify from '../../services/Notify'
import {dayMonthYearAtTimeWithSeconds} from '../../utils/dates'
import {INVENTORY_STATUS} from './InventoryStatusSelector'
import InventoryProductTypes from "../InventoryProductTypes";
import AccordionBtn from "./AccordionBtn";
import InventoryExecution from "./InventoryExecution";

function InventoryDetailBox({inventoryId}) {
  const [inventoryDetails, setInventoryDetails] = useState(null)
  const [isLoading, setLoading] = useState(false)

  const [showAccordion, setShowAccordion] = useState(true)

  const inventoryService = new InventoryService()

  const openAccordion = () => {
    setShowAccordion(!showAccordion)
  }


  const getInventoryDetails = async () => {
    try {
      setLoading(true)
      const response = await inventoryService.findById(inventoryId)
      setInventoryDetails(response)
    } catch (error) {
      Notify.error('Houve um erro ao recuperar o inventário', error)
    } finally {
      setLoading(false)
    }

  }
  useEffect(() => {
    inventoryId && getInventoryDetails()
  }, [inventoryId])

  return (
    <div>
      <Box title="Inventário">
        <LoadingV2 isLoading={isLoading}>
          <Row className="mb-5">
            <Col md={3}>
              <TextPropertyValue property="Local" value={inventoryDetails && inventoryDetails.bizLocation.friendlyName}/>
            </Col>
            <Col md={3}>
              <TextPropertyValue property="Criado por" value={inventoryDetails && inventoryDetails.createdBy}/>
            </Col>
            <Col md={3}>
              <TextPropertyValue
                property="Finalizado por"
                value={inventoryDetails && inventoryDetails.userFinished
                  && inventoryDetails.userFinished.name}
              />
            </Col>
            <Col md={3}>
              <TextPropertyValue property="Status" value={inventoryDetails && inventoryDetails.status && INVENTORY_STATUS[inventoryDetails.status]}/>
            </Col>
          </Row>
          <Row className="mb-5">
            <Col md={3}>
              <TextPropertyValue
                property="Tipo do inventário"
                value={inventoryDetails && inventoryDetails.full ? 'Completo' : 'Parcial'}
              />
            </Col>
            <Col md={3}>
              <TextPropertyValue
                property="Criado em"
                value={inventoryDetails && inventoryDetails.createdAt && dayMonthYearAtTimeWithSeconds(inventoryDetails.createdAt)}
              />
            </Col>
            <Col md={3}>
              <TextPropertyValue
                property="Finalizado em"
                value={inventoryDetails && inventoryDetails.finishDate
                  && dayMonthYearAtTimeWithSeconds(inventoryDetails.finishDate)}
              />
            </Col>
          </Row>
          <AccordionBtn
            showAccordion={showAccordion}
            onClick={openAccordion}
            label="Execuções"/>
          {showAccordion &&
            <InventoryExecution inventoryId={inventoryId}/>
          }
          {inventoryDetails && !inventoryDetails.full && <InventoryProductTypes productTypes={inventoryDetails.productTypes}/>}
        </LoadingV2>
      </Box>
    </div>
  )
}

export default InventoryDetailBox;



// WEBPACK FOOTER //
// ./src/Inventory/components/InventoryDetailBox.js